import { createReducer, on } from '@ngrx/store';
import * as actions from '../actions';

export const retirementPlanFeatureKey = 'retirement plan';

export interface RetirementPlanState {
  loadRetirementPlan: any;
  loadRetirementPlanResponse: any;
  loadRetirementPlanFailure: any;
}

export const initialState: RetirementPlanState = {
  loadRetirementPlan: undefined,
  loadRetirementPlanResponse: undefined,
  loadRetirementPlanFailure: undefined
};

export const reducer = createReducer(
  initialState,

  on(actions.loadRetirementPlan, (state, action) => ({
    ...state,
    loadRetirementPlan: action.request
  })),
  on(actions.loadRetirementPlanSuccess, (state, action) => ({
    ...state,
    loadRetirementPlanResponse: action.response
  })),
  on(actions.loadRetirementPlanFailure, (state, action) => ({
    ...state,
    loadRetirementPlanFailure: action.error
  }))
);

export const getRetirementPlan = (state: RetirementPlanState) => state.loadRetirementPlanResponse;
